import React from "react";
import cardButtonIconStyles from "../styles/CardButtonIcon.styles";

const CardButtonIcon = ({ iconName }) => {
	const classes = cardButtonIconStyles({ iconName });
	return <span className={classes.icon} />;
};

export default CardButtonIcon;
